import { bool, func, string } from "prop-types";
import * as React from "react";

import { isPresent } from "Services/helper-utils";
import { EMPTY_ARR } from "Services/constants/empty";
import Styles from "./styles.css";

class InputText extends React.Component {
	static propTypes = {
		isDisabled: bool,
		isRequired: bool,
		isValid: bool,
		label: string,
		name: string,
		onChange: func,
		value: string,
	};
	constructor(props) {
		super(props);
		this.state = {
			errors: this.validate(props.value, props.isRequired),
			isTouched: false,
		};
	}
	validate = (value, isRequired) => {
		if (isRequired && !isPresent(value)) {
			return ["Required"];
		}
		return EMPTY_ARR;
	};
	handleOnChange = (e) => {
		const { isDisabled, isRequired, name, onChange } = this.props;
		if (isDisabled) return;
		const errors = this.validate(e.target.value, isRequired);
		this.setState({
			errors,
		});
		onChange(name, e.target.value, errors.length === 0);
	};
	handleOnBlur = () => {
		if (!this.state.isTouched) {
			this.setState({
				isTouched: true,
			});
		}
	};
	render() {
		const { isDisabled, isRequired, label, name, value } = this.props;
		const { errors, isTouched } = this.state;
		return (
			<div css={Styles.wrapper(isDisabled)}>
				{isDisabled && <div css={Styles.inputCover} />}
				<textarea
					css={Styles.input(errors.length > 0, isTouched)}
					disabled={isDisabled}
					name={name}
					onBlur={this.handleOnBlur}
					onChange={this.handleOnChange}
					placeholder={isRequired ? `*${label}` : label}
					required={isRequired}
					tabIndex={1}
					value={value}
				/>
				{errors.length > 0 && (
					<div css={Styles.error(isTouched)}>{errors[0]}</div>
				)}
			</div>
		);
	}
}

export default InputText;
